import context, { IAppUserContext, AsyncComponentLoading, AsyncComponentError } from '@truckdown/components-systems';
import { IInitializer, IUserContext } from "@truckdown/systems";
import { defineAsyncComponent } from 'vue';

import developerSideNav from './DeveloperSideNav/DeveloperSideNav.vue';

class DeveloperComponentInitializer implements IInitializer {
    name: string = 'DeveloperComponentInitializer';
    order: number = 0;

    async initialize(context: IUserContext): Promise<void> {
        let app = (context as IAppUserContext).app;

        app.component('DeveloperSideNav', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-client-developer-side-nav" */ './DeveloperSideNav/DeveloperSideNav.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
    }
}

context.registerService({
    name: 'IInitializer',
    activator: async () => {
        return new DeveloperComponentInitializer();
    }
});